import { render, staticRenderFns } from "./Collapses.vue?vue&type=template&id=3e050fe7&"
import script from "./Collapses.vue?vue&type=script&lang=js&"
export * from "./Collapses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports